import EnvioApp from '../pages/EnvioApp/Index.vue'
import EnvioAppPorEquipe from '../pages/EnvioApp/PorEquipe.vue'

export default [
  {
    path: '/envio-app',
    component: () => import('@/pages/EnvioApp/Template.vue'),
    children: [
      {
        path: '/envio-app',
        component: EnvioApp,
      },
      {
        path: '/envio-app/equipe',
        component: EnvioAppPorEquipe,
      },
    ],
  },
]
